var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-renderer"},[_c(_vm.type,{tag:"component",attrs:{"shared":_vm.shared,"block":_vm.block,"single":_vm.single,"hideDownload":_vm.hideDownload},on:{"onDownload":_vm.onDownload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }